import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogConfirmSave = ({
    saveActionObj, dialog
}) => {
    if (!saveActionObj) return null;
    const { props, saveAction } = saveActionObj;
    return (
        <DialogAlertAction
            variant="secondary"
            width="680px"
            widthContent="90%"
            show={dialog.value}
            toggleShow={dialog.toggle}
            title={props.title}
            contentComponent={<p className="paragraph center">{props.content}</p>}>
            <CustomButton 
                variant="secondary" 
                width="120px"
                text="No, cancelar"
                onClick={dialog.hide}/>
            <CustomButton 
                text="Sí, guardar"
                width="120px"
                onClick={() => {
                    dialog.hide();
                    saveAction();
                }}/>
        </DialogAlertAction>
    );
}

export default DialogConfirmSave;